

export const ElfStory = {
    level: 8,
    name: 'Elven wisdom',
    cpu1Name: 'Air Elemental',
    cpu2Name: 'Earth Elemental',
    cpu3Name: 'Fire Elemental',
    text: "Elves are renowned for their wisdom. Their long lifespan allows them to accumulate numerous different knowledge. But they don't share it just like that; only those who can pass deadly trials will be initiated into a small portion of what the elves know.",
    classCss: 'map-elf-ico',
    cpu1: {
        id: 6,
        before: {
            type: 'comics',
            comicsSetting:{
                path: './img/stories/elf/intro/',
                slideNumber: 6
            }
        },
        after: {
            player: {
                type: 'text',
                step: {
                    0: "This is only the first test, it will be more difficult later",
                }
            },
            cpu: {
                type: 'text',
                step: {
                    0: 'Well try again',
                }
            }
        }
    },
    cpu2: {
        id: 5,
        before: {
            type: 'text',
            step: {
                0: "Now let's see how you handle the element of earth.",
            }
        },

        after: {
            player: {
                type: 'text',
                step: {
                    0:  "The element of earth has obeyed you; let's see how you handle the fire.",
                }
            },
            cpu: {
                type: 'text',
                step: {
                    0: "Well try again",
                }
            }
        },
    },
    cpu3: {
        id:7,
        before: {
            type: 'text',
            step: {
                0: "The element of fire is very dangerous; one can get burned in the pursuit of knowledge.",
            }
        },
        after: {
            player: {
                type: 'comics',
                comicsSetting:{
                    path: './img/stories/elf/win/',
                    slideNumber: 32
                }
            },
            cpu: {
                type: 'text',
            step: {
                0: "Don't play with fire, but conquer it.",
            }
            }
        },
    },
    cpu4: {
        id: 52,
        before: {
            type: 'text',
            step: {
                0: "Now comes the real test — all three elements together.",
            }
        },

        after: {
            player: {
                type: 'text',
                step: {
                    0:  "Very, very good. Now you’re ready for anything.",
                }
            },
            cpu: {
                type: 'text',
                step: {
                    0: "There’s nothing wrong with losing. Three elements are a very powerful force. You just need more time to prepare.",
                }
            }
        },
    },
}